import { ActionReducerMap } from "@ngrx/store";
import { uploadFileReducer } from "./reducers/upload-file.reducer";
import { UploadScreenInfo } from "src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface";
import { UploadFileContactInformation } from "../pages/contact-information/model/potential-customer";
import { uploadFileOptionalReducer } from "./reducers/contact-information.reducer";

interface AppState {
  UploadFileInfo: UploadScreenInfo;
  UploadFileContactInformationInfo: UploadFileContactInformation;
}

export const reducers: ActionReducerMap<AppState> = {
  UploadFileInfo: uploadFileReducer,
  UploadFileContactInformationInfo: uploadFileOptionalReducer,
};
